import { render, staticRenderFns } from "./NextPrevious.vue?vue&type=template&id=3acd1fb9&scoped=true"
import script from "./NextPrevious.vue?vue&type=script&lang=js"
export * from "./NextPrevious.vue?vue&type=script&lang=js"
import style0 from "./NextPrevious.vue?vue&type=style&index=0&id=3acd1fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd1fb9",
  null
  
)

export default component.exports